import { render, staticRenderFns } from "./NewsSectionDataDetails.vue?vue&type=template&id=f580b820&scoped=true&"
import script from "./NewsSectionDataDetails.vue?vue&type=script&lang=js&"
export * from "./NewsSectionDataDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f580b820",
  null
  
)

export default component.exports